import { httpClient } from '@/services/http/httpClient'

type DeleteTagProps = {
  id: string
  projectId: string
}

export const deleteTag = async ({ id, projectId }: DeleteTagProps) => {
  await httpClient.delete(`/projects/portfolio-tags/${projectId}/${id}`)
}
